import {
  InputSliderField as DSInputSliderField,
  InputSliderFieldProps,
  InputSliderFieldG4PProps,
} from "@dbn/omnichannel-design-system-g4p";
import { usePersistentFocusRestore } from "../usePersistentFocus";

export function InputSliderField(
  props: InputSliderFieldProps | InputSliderFieldG4PProps
) {
  usePersistentFocusRestore([props.value, props.disabled]);

  return <DSInputSliderField {...props} />;
}
